import React, { useEffect, useState } from "react";
import { X, MessageCircle } from "lucide-react";
import { getGallery, galleryImageUrl } from "../api";
import { company } from "../mock";
import Reveal from "./Reveal";

const waNumber = (company.whatsapp || "").replace(/[^0-9]/g, "");
const waLink = (img) =>
  `https://wa.me/${waNumber}?text=${encodeURIComponent(
    `Hi Bhawani Kitchen Equipment, I'm interested in ${img.title ? `the "${img.title}"` : "this product"} from your gallery. Please share details, price and availability.\n${img.src}`
  )}`;

const WaButton = ({ img, testId, className = "" }) => (
  <a
    href={waLink(img)}
    target="_blank"
    rel="noopener noreferrer"
    onClick={(e) => e.stopPropagation()}
    data-testid={testId}
    className={`inline-flex items-center justify-center gap-2 rounded-lg font-semibold text-white bg-[#25D366] hover:bg-[#1ebe57] transition-colors ${className}`}
  >
    <MessageCircle size={16} /> WhatsApp Enquiry
  </a>
);

export default function Gallery() {
  const [images, setImages] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    getGallery().then((d) => setImages(d.map((it) => ({ id: it.id, title: it.title, src: galleryImageUrl(it) })))).catch(() => {});
  }, []);

  return (
    <section id="gallery" className="py-20 md:py-28 bg-white" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <Reveal className="text-center max-w-2xl mx-auto mb-14">
          <p className="overline text-sm mb-1">Our Work</p>
          <h2 className="section-title text-3xl md:text-5xl mb-4">Gallery</h2>
          <p className="text-slate-600">A glimpse of our commercial kitchen equipment.</p>
        </Reveal>

        {images.length === 0 ? (
          <p className="text-center text-slate-400" data-testid="gallery-empty-public">Photos coming soon.</p>
        ) : (
          <div className="columns-2 md:columns-3 lg:columns-4 gap-4 [column-fill:_balance]">
            {images.map((img, i) => (
              <Reveal key={img.id} delay={(i % 4) * 60} className="mb-4 break-inside-avoid">
                <div className="overflow-hidden rounded-2xl border border-slate-100 bg-slate-50">
                  <button onClick={() => setActive(img)} data-testid={`gallery-item-${img.id}`} className="group block w-full overflow-hidden">
                    <img src={img.src} alt={img.title || "Bhawani Kitchen Equipment"} className="w-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
                  </button>
                  <div className="p-2">
                    <WaButton img={img} testId={`gallery-whatsapp-${img.id}`} className="w-full py-2 text-sm" />
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        )}
      </div>

      {active && (
        <div className="fixed inset-0 z-[60] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4" onClick={() => setActive(null)} data-testid="gallery-lightbox">
          <button className="absolute top-5 right-5 h-11 w-11 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white" data-testid="gallery-lightbox-close">
            <X size={22} />
          </button>
          <div className="max-w-4xl w-full" onClick={(e) => e.stopPropagation()}>
            <img src={active.src} alt={active.title || "Bhawani Kitchen Equipment"} className="w-full max-h-[75vh] object-contain rounded-xl bg-white" />
            <div className="flex justify-center mt-4">
              <WaButton img={active} testId="gallery-lightbox-whatsapp" className="px-6 py-3" />
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
